import { render, staticRenderFns } from "./Aliados.vue?vue&type=template&id=247256cc&"
import script from "./Aliados.vue?vue&type=script&lang=js&"
export * from "./Aliados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports